// UserContext.js
import React, { createContext, useCallback, useContext } from "react";
import getClient from "../../helpers/get-client";
import { enviarZonaHorariaUnaVez } from "../../helpers/zona-horaria";

const client = getClient();

const UserContext = createContext();

export const useCurrentUser = () => {
  return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const refreshUser = useCallback(async () => {
    if (!localStorage.getItem("authToken")) {
      setCurrentUser(null);
      setLoading(false);
      return null;
    }
    try {
      const response = await client.get("/api/user/me/");
      setCurrentUser(response.data);
      setError(null);
      // #1301 R14: la Comunidad ubica por país; la zona horaria es la última fuente. Una vez
      // por sesión y cuenta, sin esperar ni mostrar nada (ver helpers/zona-horaria.js).
      enviarZonaHorariaUnaVez(response.data && response.data.id, client);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if (!localStorage.getItem("authToken")) {
      setLoading(false);
      setCurrentUser(null);
      return;
    }
    refreshUser().catch(() => {});
  }, [refreshUser]);

  const value = { currentUser, loading, error, refreshUser };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
